var _defs, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _polygon, _polygon2, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _circle8, _circle9, _path78, _path79, _path80, _path81, _path82, _path83, _polygon3, _path84, _path85, _g2, _path86, _path87, _polygon4, _path88, _path89, _path90, _path91, _circle10, _circle11, _circle12, _g3, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _g4, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g5, _path127, _path128, _path129, _polygon5, _polygon6, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _circle13, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g6, _ellipse6, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _polygon7, _path153, _path154, _polygon8, _polygon9, _g7, _g8, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path209, _ellipse14, _path210, _path211;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "271e5882-3c8d-41ed-8a0a-1cb2b4d0cbc1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1137.68,
    height: 859.71,
    viewBox: "0 0 1137.68 859.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1d1d90cb-e8d6-4c10-b901-192027040f7e",
    x1: 512.79,
    y1: 730.45,
    x2: 512.79,
    y2: 139.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8425757a-56ab-41b8-890b-c9acfe5ccb1b",
    x1: 703.39,
    y1: 781.93,
    x2: 703.39,
    y2: 171.12,
    xlinkHref: "#1d1d90cb-e8d6-4c10-b901-192027040f7e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "422858ff-741c-491e-b83f-4f975ae951a6",
    x1: 876.05,
    y1: 827.31,
    x2: 876.05,
    y2: 239.74,
    xlinkHref: "#1d1d90cb-e8d6-4c10-b901-192027040f7e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb632b7f-b2f8-40b2-b1bc-4aa48a1a2180",
    x1: 479.8,
    y1: 818.68,
    x2: 479.8,
    y2: 229.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 828.87, 0)",
    xlinkHref: "#1d1d90cb-e8d6-4c10-b901-192027040f7e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9b8149d4-8e0d-43dc-bd85-6bf0bb4ef8aa",
    x1: 561.7,
    y1: 875.44,
    x2: 561.7,
    y2: 737.82,
    xlinkHref: "#1d1d90cb-e8d6-4c10-b901-192027040f7e"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team spirit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.44,426.65c18,70.15,56.11,130.79,116.34,160.18C285,647.92,567.23,616.41,777.9,580.25c109-18.71,204.74-70.3,274.33-143Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.21,96.46H1032.62c-5.5,0-10-4.1-10-9.11s4.49-9.11,10-9.11h20c-5.5,0-10-4.1-10-9.11s4.49-9.1,10-9.1h-14.27c-5.5,0-10-4.1-10-9.11s4.49-9.11,10-9.11h60.33c-13.39-5.68-29-9.71-47.06-11.82-164.51-19.27-223.25-6.53-244,6.58a242.11,242.11,0,0,1-84.55,33.79C621.57,89.45,431.75,112.42,259.7,63,174.19,38.45,110.64,80,72.54,149.31H1168.28c-1.43-20.16-5.71-38.78-13.57-55.07A10.48,10.48,0,0,1,1148.21,96.46Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.63,280.23a423.94,423.94,0,0,0,4.49,122.39L1053,436.46a433.15,433.15,0,0,0,70.51-98ZM435,367.54h-20c5.49,0,10,4.1,10,9.11s-4.5,9.1-10,9.1H299.46c-5.49,0-10-4.09-10-9.1s4.5-9.11,10-9.11h20c-5.49,0-10-4.1-10-9.11s4.5-9.11,10-9.11H305.17c-5.49,0-10-4.09-10-9.1s4.5-9.11,10-9.11H420.76c5.5,0,10,4.1,10,9.11s-4.49,9.1-10,9.1H435c5.5,0,10,4.1,10,9.11S440.53,367.54,435,367.54Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.33,149.94l-1108,24.57C46.83,206.1,37.9,241.81,33.78,278.83H1148.91a399,399,0,0,0,16.1-66.49C1168.33,190.58,1169.66,169.54,1168.33,149.94ZM258.75,230.45h-20c5.49,0,10,4.1,10,9.11s-4.5,9.11-10,9.11H123.17c-5.49,0-10-4.1-10-9.11s4.5-9.11,10-9.11h20c-5.49,0-10-4.09-10-9.1s4.5-9.11,10-9.11H128.88c-5.49,0-10-4.1-10-9.11s4.5-9.11,10-9.11H244.47c5.5,0,10,4.1,10,9.11s-4.49,9.11-10,9.11h14.28c5.49,0,10,4.1,10,9.11S264.24,230.45,258.75,230.45Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.34,
    cy: 749.94,
    rx: 75.23,
    ry: 16.89,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 839.15,
    cy: 803.58,
    rx: 135.72,
    ry: 11.14,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.22,
    cy: 786.69,
    rx: 135.72,
    ry: 16.89,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.15,
    cy: 702.14,
    rx: 102.12,
    ry: 16.89,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.66,
    cy: 842.82,
    rx: 81.75,
    ry: 16.89,
    fill: "#112969",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M608.62,320.47C606.46,305.93,593.25,272,593.25,272h0c-.23-1-.49-2-.78-3C583.1,236.8,570.13,234,570.13,234L523.67,224a3.6,3.6,0,0,1,1,.93,6.45,6.45,0,0,0-.73.11,18.2,18.2,0,0,1-4.07-8.8c-.09-.48-.17-1-.23-1.49a32.68,32.68,0,0,0-2.66-49.13c-.49-.38-1-.75-1.49-1.1,2.19-2.33,2.26-5.57.62-8.81-3.66-7.6-11.62-12.41-19.8-14.76-6.25-1.79-13-2.37-19.22-.41-3.53,1.12-6.75,3-10.06,4.67-6.17,3.08-13,5.52-17.61,10.59-1.08,1.18-2.08,2.69-1.76,4.25.24,1.16,1.16,2.06,1.75,3.09,1.33,2.31,1,5.22.09,7.74s-2.24,4.86-2.87,7.44-.39,5.62,1.55,7.47a32.91,32.91,0,0,0,2.9,2,15.21,15.21,0,0,1,2.77,3.11q2.76,3.7,5.5,7.43a76.54,76.54,0,0,1,6.89,10.47c1.37,2.7,2.43,5.58,4.26,8a11.86,11.86,0,0,0,1.83,1.92l-.54-.21A8.33,8.33,0,0,0,477.9,221h0c.1,0,.19,0,.28,0a1.68,1.68,0,0,0,1.12-.46c0,.34,0,.68,0,1,.11,3.57.09,7.37-.16,10.94l-.43-.22a3.75,3.75,0,0,0-4,.42L431.94,267s-9.3,12.72-8,34.68l-7.5,32.93s-9.37,27.94-2.16,47.89,11.39,31.36,11.39,31.36,2.88,22.67,7.21,24.52,6.2,2.85,6.2,2.85l.86,5.42h0s.29.53.8,1.42c3.15,5.48,14.82,24.82,21.6,22.75a86.69,86.69,0,0,1,1.1,15.89l6.71,45.05s4.68,12.25,4.39,18.67S480,566,480,566a29.75,29.75,0,0,0-2.88,20.95c2.74,12,6.2,67.28,6.2,67.28l5,13.4-.14,15.71a15,15,0,0,1-3.1,7c-3.24,3.52-3,7.59-10.81,12.4s-12.76,6.63-12.76,13a16.72,16.72,0,0,1-.24,2.65c-.72,4.68-2.12,7.22,12.24,8.58,16.87,1.6,28.12-9.4,28.12-9.4s2.48-4.5,14.16-6.32c0,0,4-.21,4.21-3.74.08-1.22.06-3.55,0-6.12-.19-4.89-.66-10.6-1.28-10.88-.78-.35-2.14-5.27-2.61-7.05h3.25s3-22.67,0-37.35-.29-25.09-.29-25.09l-.58-38.77s-4-4.28-.86-11.84,0-44.9,0-44.9,1.16-13.4,4.47-16.54.16-19.63,0-20.49l5.9,19.79s2.59,39.34,8.08,46.46l1.58,17.82s11.24,16.4,9.08,25.23,2.31,40.77,2.31,40.77v32.65s-5.05,13.11,2,17.82l3-.12c-1,.93-1.77,2.33-2.94,3.54-1.35,1.39-2.12,6.68-2.55,11.23-.36,3.85-.48,7.16-.48,7.16s3,4.8,8.65,5.13S581,730.45,581,730.45s18.39,0,23.15-1l.28-.07a6.25,6.25,0,0,0,3.59-2.93,7.5,7.5,0,0,0,.86-5.39c-.59-2.81-2.82-5.89-7.76-8.51C588.83,706.07,587,700,587,700l-8.07-12.11,1.15,0s-.71-12.83,8.07-27.23l-.57-63.43s3.6-21.81-2.59-33.65c0,0-.51-12.54,3.63-16.39s-5.51-42.76-5.51-42.76-2-20.89-4.35-39.95l0,0c9.73,9.23,19.82-24,21.52-29.91l.25,0-.11-.43c.07-.28.11-.42.11-.42h0s-2.16-7.68-.58-6.12,5.48-4.28,5.48-4.28-.58-31.79,6.2-47.81S608.62,320.47,608.62,320.47Zm-29,20.23.05-.09c1,19.41-.19,60.83-.19,60.83s-1.34,5.31-2.77,11.56l-1-39.35h0l-1-37.07ZM455.51,327.32s4.9,61.29,0,70.13c-1.39,2.52-2.56,7-3.53,12.11-1.62-4.25-5.05-14.23-3.82-19.52,1.59-6.84-3.17-24.81-3.17-25.23s-.43-10,3-17.32S449.17,337,449.17,337,452.05,325,455.51,327.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "url(#1d1d90cb-e8d6-4c10-b901-192027040f7e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M467.45,465.36c-4.27,18.77-21.25-9.61-25.12-16.42-.5-.89-.78-1.41-.78-1.41l1.84-8.63,9.73-4a27.18,27.18,0,0,1,4.36,2.84C462.81,441.93,470.74,450.82,467.45,465.36Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d38884"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M599.18,434.65s0,.14-.11.42c0,.12-.08.28-.13.45-1.67,5.86-11.57,38.85-21.13,29.69-10.46-10-5.38-33.12-5.38-33.12h.07l22-2.25,4.36,4.48s0,0,0,0Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d38884"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M586.45,597l.56,63c-8.63,14.3-7.92,27-7.92,27l-28.44,1.12c-6.94-4.67-2-17.68-2-17.68V638s-4.39-31.69-2.27-40.47-8.91-25-8.91-25l-1.56-17.69c-5.38-7.07-7.93-46.12-7.93-46.12L522.21,489c.16.85,3.16,17.31,0,20.34s-4.39,16.41-4.39,16.41,3.11,37.08,0,44.57.84,11.75.84,11.75l.57,38.49s-2.69,10.33.28,24.9,0,37.08,0,37.08H489l.14-15.71-4.94-13.3s-3.4-54.9-6.09-66.79a29.84,29.84,0,0,1,2.82-20.8s-5.65-9.05-5.37-15.42S471.2,532,471.2,532l-6.58-44.71a86.86,86.86,0,0,0-3.26-25.47c-3.82-12.74-9.48-29.44-9.48-29.44l6.39.57,32.24,2.87s78.39-5.27,81.9-.89a14.71,14.71,0,0,1,1.48,4.57c3.52,15.81,8.17,65.34,8.17,65.34s9.48,38.63,5.41,42.45-3.57,16.26-3.57,16.26C590,575.3,586.45,597,586.45,597Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#444053"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.18,706.43c-.22,3.51-4.13,3.72-4.13,3.72-11.46,1.8-13.9,6.26-13.9,6.26s-11,10.93-27.59,9.34c-14.1-1.36-12.73-3.87-12-8.52a17.62,17.62,0,0,0,.23-2.62c0-6.37,4.88-8.18,12.52-13s7.43-8.81,10.61-12.31,3.51-10.29,3.51-10.29c3.6-6.27,12.73,1,12.73,1,.43,2.22,14,1.91,14,1.91s1.8,7.22,2.73,7.64c.61.28,1.07,5.94,1.25,10.8C520.24,702.91,520.26,705.22,520.18,706.43Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#b07473"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M520.18,706.43c-.22,3.51-4.13,3.72-4.13,3.72-11.46,1.8-13.9,6.26-13.9,6.26s-11,10.93-27.59,9.34c-14.1-1.36-12.73-3.87-12-8.52,6.3,1.56,18.34,3.74,25.37-.08,9.77-5.3,16.78-9,16.78-9l15.44-7.77C520.24,702.91,520.26,705.22,520.18,706.43Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M606.55,725.32a6.1,6.1,0,0,1-3.52,2.91l-.27.07c-4.67,1-22.72,1-22.72,1s-18.25-14.11-23.77-14.43-8.49-5.1-8.49-5.1.11-3.28.46-7.1c.43-4.52,1.18-9.77,2.51-11.15,2.44-2.55,3-6,8.49-3.82,0,0,7.84-13.82,17.08-3.14l9.56,14.5s1.8,6,13.91,12.51c4.84,2.6,7,5.66,7.61,8.45A7.45,7.45,0,0,1,606.55,725.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#b07473"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M606.55,725.32c-1.08.91-2.27,1.89-3.52,2.91l-.27.07c-4.67,1-22.72,1-22.72,1s-18.25-14.11-23.77-14.43-8.49-5.1-8.49-5.1.11-3.28.46-7.1c5.62,1.68,14.13,4.65,16.41,7.85,3.5,4.87,14.13,11.67,14.13,11.67s19.82-1.91,28.62-2.17A7.45,7.45,0,0,1,606.55,725.32Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M529.42,231.53l-26.1,27.59s-31.63-2.33-26.11-11.67c2.81-4.76,3.25-14.72,3-23.38-.23-8.35-1.09-15.46-1.09-15.46s44.36-22.08,41-1.49a33.89,33.89,0,0,0-.12,11.75C521.89,229.27,529.42,231.53,529.42,231.53Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d38884"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M520.08,207.12a33.89,33.89,0,0,0-.12,11.75,32.56,32.56,0,0,1-23.22,9.69c-6,0-12.49-4.93-17.34-7.78-.23-8.36-.28-12.17-.28-12.17S523.48,186.53,520.08,207.12Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M529.42,194.17a32.69,32.69,0,1,1-12.3-25.54A32.69,32.69,0,0,1,529.42,194.17Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d38884"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M573.89,439.5c-8.14,19.37-60.5,19.77-60.5,19.77V438.15l-3.17-.21c1.37,6.05-1.92,20.8-1.92,20.8C466.92,464.58,456.83,441,456.83,441l1.44-8.07,32.24,2.87s78.39-5.27,81.9-.89A14.71,14.71,0,0,1,573.89,439.5Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M513.39,456.72V435.6l-3.17-.2c1.37,6-1.92,20.8-1.92,20.8-31.14,4.39-44.56-7.87-49.29-14.21a19.35,19.35,0,0,1-2.18-3.52l12.64-71.1,3-104.64L477,244.37l1.05-8.81v-.1l.11,0,3.22,1.38,19.27,8.33,21.89-16.53.32-.23,1.09-.83,1.81,1.45,4.5,3.61,14.43,93.19s25,71.75,29.68,100.71c.19,1.16.34,2.24.46,3.25C577.92,456.23,513.39,456.72,513.39,456.72Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 471.83,
    cy: 227.09,
    r: 1.86,
    fill: "#67647e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.69,
    cy: 244.07,
    r: 1.86,
    fill: "#67647e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.55,
    cy: 271.56,
    r: 1.86,
    fill: "#67647e"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.62,
    cy: 301.17,
    r: 1.86,
    fill: "#67647e"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.48,
    cy: 328.97,
    r: 1.86,
    fill: "#67647e"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.34,
    cy: 358.58,
    r: 1.86,
    fill: "#67647e"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.6,
    cy: 387.87,
    r: 1.86,
    fill: "#67647e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M479.29,377.71s-2.08,27.23-5.9,35.15S467.87,443,467.87,443L459,442a19.35,19.35,0,0,1-2.18-3.52l12.64-71.1,3-104.64L477,244.37l1.05-8.81.12-.05a3.58,3.58,0,0,1,3.16.05l.42.22q-.19.54-.36,1.11c-3.46,10.83-4.75,30.79-4.75,30.79s5,36.51,5.52,53.49S479.29,377.71,479.29,377.71Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M457.48,437.77a5.13,5.13,0,0,1-.34.66c-3.44,5.81-12.16,9.5-14.81,10.51-.5-.89-.78-1.41-.78-1.41l1.84-8.63,9.73-4A27.18,27.18,0,0,1,457.48,437.77Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M433.91,298.81l-8.07,4.81-7.35,32.69s-9.2,27.73-2.13,47.54S427.54,415,427.54,415s2.83,22.5,7.08,24.34,6.08,2.83,6.08,2.83l.85,5.38s11.52-3.91,15.59-10.8-3-24-3-24-6.08-14.58-4.52-21.37-3.12-24.62-3.12-25-.42-9.91,3-17.2,1.14-10.4,1.14-10.4l-2.13-20.8Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#67647e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M574.56,433.38s-21.37,8.06-28.16,1-6.09-40.19-6.09-40.19-6.5-61.13-10.61-71.17-2-82.5-2-82.5-2.76-9.37-5.17-11.82a2.62,2.62,0,0,0-.51-.41l.83.18,2.9.62,4.5,3.61,14.43,93.19s25,71.75,29.68,100.71Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M599.18,435.5l-.24,0c-2.69.35-26.43,3.22-26.53-1.72a14.47,14.47,0,0,1,.09-1.71l22-2.25,4.36,4.48s0,0,0,0c.08.29.14.54.2.74Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M576.4,266.07,592,274.21s13,33.66,15.08,48.09c0,0,9.63,38.66,3,54.56S604,424.32,604,424.32s-3.82,5.8-5.38,4.25.57,6.08.57,6.08-26.67,3.54-26.78-1.7,6.12-30.28,6.12-30.28,1.7-59.57-.71-68.91S576.4,266.07,576.4,266.07Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#67647e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M529.85,329.52s-8.78,21.5-11.61,22.92.57,7.07.57,7.07S534.8,337.16,529.85,329.52Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M524.61,254.1c.1-.41-10.47,10.37-13.3,12S521.64,266,524.61,254.1Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M495.18,327.82s-16.13,10.43-14,14.56S495.18,327.82,495.18,327.82Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M524.47,480.07s13.73,8.83,35.09,11Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M491.5,501.3s12.73,16,18.54,16.41S491.5,501.3,491.5,501.3Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M509.33,564c-.57.28-7.22,14.43-14,14.86S509.33,564,509.33,564Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M568.33,595s12.62-2.83,15.43,6.22C583.76,601.19,582.91,598.36,568.33,595Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M559.84,646.76s15.29-3.12,18.54,1.13S559.84,646.76,559.84,646.76Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M516.59,654c0,.14-15.56,3.12-15,5.1s16.6,1.7,17.17-1.42A3,3,0,0,0,516.59,654Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M554.75,667.42s25.57-3.12,24,2.26S554.75,667.42,554.75,667.42Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M420.89,352.44c.14.42,16.84,2.69,19.1,8.07,0,0-16.41-7.65-19-7.65",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M444.38,396.16s-13.87,4.39-12.88,11S430.09,404.1,444.38,396.16Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M437.92,429.84s5.05-6.93,9.86-5.66S437.92,429.84,437.92,429.84Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M517.12,168.63a7.87,7.87,0,0,1-1.62,1.21c-4,2.33-5.1,5.92-7,10.06-1.77,3.79-3.72,7.8-7.29,9.95-4.61,2.78-10.68,1.76-15.47,4.18a12,12,0,0,0-6.4,11.83,34.12,34.12,0,0,0,1.36,5.42,38.65,38.65,0,0,1,1.46,11.77,2,2,0,0,1,0,.35,32.68,32.68,0,1,1,35-54.77Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M516.27,158.79c-3.59-7.54-11.4-12.32-19.43-14.65-6.13-1.77-12.79-2.35-18.87-.4-3.47,1.1-6.62,3-9.87,4.63-6.06,3.06-12.72,5.48-17.28,10.51-1.07,1.17-2,2.67-1.73,4.22.23,1.15,1.13,2,1.71,3.06,1.31,2.3,1,5.19.09,7.69s-2.2,4.82-2.82,7.39-.38,5.58,1.52,7.41c.85.81,1.94,1.32,2.86,2a15.05,15.05,0,0,1,2.71,3.08l5.4,7.38a74.85,74.85,0,0,1,6.76,10.39c1.34,2.68,2.38,5.54,4.18,7.93s4.6,4.31,7.58,4.05a1.47,1.47,0,0,0,1.2-.57,1.58,1.58,0,0,0,.15-.75A38.38,38.38,0,0,0,479,210.43a33.85,33.85,0,0,1-1.36-5.42,12.05,12.05,0,0,1,6.4-11.83c4.8-2.42,10.87-1.4,15.47-4.17,3.58-2.16,5.53-6.17,7.29-10,1.93-4.14,3-7.73,7-10.06S518.26,162.76,516.27,158.79Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#585268"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M501.63,693.06s5,6.37,3.7,10S501.63,693.06,501.63,693.06Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M569.28,709s1.11-8.54,5.56-8.62,4.67-.46,8.07.85,6.59,3.34,5.57,3.64-5.85-4.88-10.81-2.23A35.72,35.72,0,0,0,569.28,709Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M486.71,255.88l14-9.81s-20.48-12.1-22.92-10.4-4.12,17-4.12,17Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M486.65,255.25l14-10s-20.48-12.1-22.92-10.4-4.12,17.84-4.12,17.84Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#e1e7ef"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M486.65,255.25l14-10s-20.48-12.1-22.92-10.4-4.12,17.84-4.12,17.84Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M480.05,234.93l-.42-.21a3.63,3.63,0,0,0-3.93.41l-42,34.07s-9.13,12.63-7.86,34.42l24.77,35.09s2.83-11.88,6.22-9.62c0,0,4.81,60.85,0,69.62s-6.93,41.6-6.93,41.6l16.27,1.84s1.7-22.22,5.52-30.14,5.9-35.15,5.9-35.15,3.44-39.56,2.87-56.54-5.52-53.49-5.52-53.49S476.33,245.43,480.05,234.93Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#67647e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M521.89,249.68l-17.45-6.46s22.22-24.34,25-10.84Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M521.89,248.83l-17.45-6.46s22.22-24.34,25-10.84Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#e1e7ef"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M521.89,248.83l-17.45-6.46s22.22-24.34,25-10.84Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M521.32,228.12a1,1,0,0,1,.72.16Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M523,226.43l46.3,10s12.74,2.83,21.94,34.81-12.6,71.16-12.6,71.16l-4.81-4.09,2.41,93.39s-21.37,8.06-28.16,1S542,392.48,542,392.48s-6.51-61.12-10.62-71.17-2-82.49-2-82.49S525.6,225.87,523,226.43Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#67647e"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M565.36,285.94c-.65.6-1.41,28.86,1.42,50.37a274.5,274.5,0,0,0,8,38.77l-4.2-86.17S567.34,284.1,565.36,285.94Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M559.7,261.6c1.13.71,6.09,12.45,3.82,17.26S559.7,261.6,559.7,261.6Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M516,158.79a25.56,25.56,0,0,0-10.18-10.66,24.21,24.21,0,0,1,7.63,9c2,4,1.41,8-2.48,10.19s-5.1,5.92-7,10.06c-1.77,3.79-3.72,7.8-7.3,10-4.6,2.78-10.67,1.75-15.47,4.17a12.08,12.08,0,0,0-6.4,11.84,34,34,0,0,0,1.37,5.41,38.68,38.68,0,0,1,1.46,11.77,1.58,1.58,0,0,1-.16.75,1.43,1.43,0,0,1-1.19.57,6.89,6.89,0,0,1-3.49-.65,8.12,8.12,0,0,0,6,2.35,1.18,1.18,0,0,0,1.34-1.32,38.37,38.37,0,0,0-1.45-11.77,32.85,32.85,0,0,1-1.37-5.42,12.05,12.05,0,0,1,6.4-11.83c4.8-2.42,10.87-1.4,15.47-4.17,3.58-2.16,5.53-6.17,7.29-10,1.93-4.14,3-7.73,7-10.06S518,162.76,516,158.79Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M800.87,284.37c-13.78-.27-25.94-10-32.83-21.89a22,22,0,0,1-3.32-9.37,10.82,10.82,0,0,1,.38-2.24,23.24,23.24,0,0,0,1-3.43,6,6,0,0,0,0-1.4s0,0,0-.08c.33-2.53-1.16-5-3-6.73s-4.15-3-6.07-4.72c-5.92-5.2-7.72-13.54-7.83-21.48v-.42c.07-3.4.34-6.81.31-10.21a42.93,42.93,0,0,0-.25-5.78c-.57-4.81-2.4-9.71-6.18-12.78-9.86-8-26.44.33-36.65-7.23-2.48-1.85-4.49-4.58-7.5-5.3-2.27-.55-4.63.19-6.85.93-7.52,2.48-15.91,5.74-18.85,13-1.68,4.17-1.21,8.93-2.75,13.15-1,2.83-2.91,5.26-4.3,7.94a12.43,12.43,0,0,0-1.6,6.63,7.48,7.48,0,0,0,.49,3.53,9,9,0,0,0,2.45,3.51,11.65,11.65,0,0,1-1.46,2.34c-1.92,2.35-4.87,4-6.87,6.34-3.7,4.29-3.56,10.12-1.74,15.16s5.11,9.63,7.38,14.54c1,2.13,1.76,4.51.75,6.63-.71,1.47-2.18,2.59-3.32,3.86a12.13,12.13,0,0,0-3,6.7c-22.51,5.14-22.53,23.23-22.53,23.23h0l-12.16,30.58s-1.95,5.15-4.24,11.95l-14.39-2.58,10,16.74c-1.89,6.82-3.23,13.14-2.79,16.32,0,0-4.47,21,3.48,24.67l17.54,7.89a10.39,10.39,0,0,0,2.43,1.09l.71.32a1.88,1.88,0,0,0,1.64,0H639l.19,0a2.36,2.36,0,0,0,1-.15,2,2,0,0,0,.88-.95.3.3,0,0,1,0-.1l5.25-1.52,4.45,5.27c2,1.41,4,2.63,5.89,3.73l-6.89,68.42s-1.11,91-4.47,111.74c-1.24,7.68-1.25,12.92-.78,16.48l-.13.22c.83,5.85,3,7,3,7l0-.08a.65.65,0,0,0,.13.08,58.91,58.91,0,0,1,3.6-7.72c0,.49,0,1,0,1.5-.07,7.72-.31,18.53-1.11,25.56-1.36,12,3.48,51.55,3.48,51.55l1.67,36a33.28,33.28,0,0,1-4.1,17.54c-4,7.19-9.11,17.31-9.48,21.8a4.5,4.5,0,0,0,0,.73h0L633,773.2s-3.35,5.18,4.22,7.27c4.07,1.13,11.09,0,16.73-1.33a11.18,11.18,0,0,0,8.67-10.88,38.5,38.5,0,0,1,7.08-13.59l1.41,8.29,9.44,2.34,1.21-22.72a10,10,0,0,0,.65-4v0c1.86-16.16-4.38-14.71-4.38-14.71a.87.87,0,0,1,.3.56l-.3-.55h0c-3.83-7.56-2-20-2-20s5-36,6.71-45.51c1.23-6.72.72-28.72.31-41,0-.51,0-1-.05-1.49,14.64-.19,32.58-.68,45.17-1.9l0,1.48-2.32,85.05a46.69,46.69,0,0,1-3.26,15.82c0,.1-.07.19-.11.29a69,69,0,0,0-4.61,22.29l-1.08,27,0,.75h0c-1.88.72-4.85,2.81-4.93,8.87-.13,8.88,15.52,5.92,15.52,5.92,15.64,0,15.77-16.28,15.77-16.28s.49-14.93,1.24-24.92-2.36-7.79-2.36-7.79l-.24,28.42c0,.07,0,.14,0,.22V736.19l.24-3.61v-.1h0l0-.77L744,702.4s14.41-48.84,16.64-58.21c1.59-6.66.93-26.72.41-37.81,0-.51,0-1-.08-1.47,4.47-.4,8.42-.44,10-.44h.73s-.74-78.44-2.61-108-4.84-56.61-12.29-64.75c-4.5-4.92-10.77-20.11-15-31.36a156.88,156.88,0,0,0,27.57,9c23.59,4.94,20.36-15.54,20.36-15.54l-2.39-38.73h.16a197.48,197.48,0,0,0-2.6-30.28c-1.25-7.68-3.16-15.62-6.08-22,2.56-1,5.09-2.07,7.57-3.17,6.41-2.83,13.63-6.84,14.55-13.75h-.31A8.92,8.92,0,0,0,800.87,284.37Zm-146.23,56h0c.05,4-.1,10.94-.34,18.61l-7.49-10,7.51-12.18ZM755,360.68Zm3.12,15.13-12.48-4a56,56,0,0,1,7.71-9.54l1.08-1-.39.08.6-.55.36-.08-.57.55.68-.14a21.29,21.29,0,0,0,4.25,8.55C763.84,374.57,758.13,375.81,758.13,375.81Z",
    transform: "translate(-31.16 -20.14)",
    fill: "url(#8425757a-56ab-41b8-890b-c9acfe5ccb1b)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "651.15 715.66 649.69 743.34 640.38 741.01 638.42 729.5 651.15 715.66",
    fill: "#a27772"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "651.15 715.66 649.69 743.34 640.38 741.01 638.42 729.5 651.15 715.66",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M716.48,767.15l14.2,2.94,10.53-9.3V734.58l.24-3.58v-.11h0l0-.76L743.41,701s14.21-48.49,16.42-57.8c1.56-6.6.91-26.52.39-37.53-.21-4.51-.39-7.53-.39-7.53l-31.35-7.59-.66,24.1-2.29,84.44a46.79,46.79,0,0,1-3.21,15.71l-.11.29a68.72,68.72,0,0,0-4.55,22.12l-1.06,26.85,0,.74Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#cc818c"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M741.45,730.15v.74h0l0-.76Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M716.48,767.15l14.2,2.94,10.53-9.3v-2.23a3,3,0,0,1-1.51,2.4l-.15.09a28.3,28.3,0,0,1-15.94,3.15l-5.54-.47a5.19,5.19,0,0,0-1.47.36l0,.74Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M739.55,761.78l.15-.08a3,3,0,0,0,1.53-2.6l.23-28.21s3.06-2.19,2.32,7.73-1.22,24.74-1.22,24.74-.12,16.16-15.55,16.16c0,0-15.43,2.94-15.31-5.88s6.37-9.18,6.37-9.18l5.54.48A28.23,28.23,0,0,0,739.55,761.78Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#b07473"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M642.52,761.15c.36,6.37,19.1,2.69,19.1,2.69l12.61-24.48s10.53-8.09,5.26-15.19a11.33,11.33,0,0,1-.77-1.21s0,0-.05-.06v0c-.11-.18-.21-.37-.31-.57h0c-3.78-7.5-1.92-19.8-1.92-19.8s4.89-35.76,6.61-45.19c1.21-6.66.71-28.51.31-40.73-.16-5.08-.31-8.49-.31-8.49l-31.11-8.33s0,3.88,0,9.28c-.07,7.67-.31,18.4-1.1,25.38-1.34,11.87,3.43,51.18,3.43,51.18l1.65,35.77a33.13,33.13,0,0,1-4,17.41c-3.9,7.14-9,17.2-9.35,21.65A4.38,4.38,0,0,0,642.52,761.15Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#cc818c"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M642.52,761.15c.36,6.37,19.1,2.69,19.1,2.69l12.61-24.48s10.53-8.09,5.26-15.19a11.33,11.33,0,0,1-.77-1.21c-.17,3.71-4.24,13-4.24,13s-10.41,20.83-13.72,25.6-17.69-.89-18.23-1.09A4.38,4.38,0,0,0,642.52,761.15Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M678.36,722.3s6.16-1.43,4.32,14.61v0a10.33,10.33,0,0,1-4.87,9.17c-4.41,2.77-11.21,8.73-14.65,20.32h0a11.08,11.08,0,0,1-8.55,10.8c-5.56,1.3-12.49,2.44-16.5,1.32-7.47-2.08-4.16-7.22-4.16-7.22l8.57-10.17s14.94,5.88,18.24,1.1,13.72-25.59,13.72-25.59S680.19,723.65,678.36,722.3Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#b07473"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M728.48,593.52l-.66,24.1c8.35-.81,14.33-1.94,15.35-3.53,2.21-3.42,10.23-4.86,17.05-5.45-.21-4.51-.39-7.53-.39-7.53Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M651.94,612a11.44,11.44,0,0,1,3.43-4.14c3.3-1.83,2.94,11.76,2.94,11.76s11,.1,25.05-.08c-.16-5.08-.31-8.5-.31-8.5l-31.11-8.32S652,606.58,651.94,612Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M648.39,615.22s3.68-10,7-11.78,2.94,11.75,2.94,11.75,80.82.74,84.86-5.51,27.55-5.88,27.55-5.88-.73-77.88-2.57-107.26-4.77-56.21-12.12-64.29c-4.75-5.23-11.51-22.15-15.69-33.43-2.27-6.16-3.78-10.65-3.78-10.65l-77.14,4.4-.63,6.25-8.19,81.92s-1.1,90.37-4.41,110.94S648.39,615.22,648.39,615.22Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#444053"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M736.91,609.68c4-6.24,27.55-5.88,27.55-5.88s-.73-77.88-2.57-107.26-4.77-56.21-12.12-64.29C745,427,738.26,410.1,734.08,398.82c-1.91-5.18-3.28-9.17-3.66-10.31l6-.34s1.51,4.49,3.79,10.65c4.18,11.28,10.93,28.2,15.68,33.43,7.35,8.08,10.29,34.9,12.12,64.29s2.58,107.26,2.58,107.26-23.51-.36-27.56,5.88c-3.45,5.33-62.92,5.58-80.18,5.53C685,615.16,733.79,614.5,736.91,609.68Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.11,603.44c1.49-.83,2.23,1.47,2.6,4.26a57.68,57.68,0,0,0-3.47,7.52s-2.13-1.15-3-7C646.46,606.13,647.81,604.16,649.11,603.44Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M672.23,199.74c-5.34,7.28.06,17.63-5.67,24.71-1.89,2.34-4.8,4-6.77,6.3-3.65,4.26-3.51,10.05-1.72,15.05s5,9.56,7.28,14.44c1,2.11,1.74,4.48.74,6.58-.7,1.46-2.15,2.57-3.28,3.83-3.68,4.11-3.78,9.82-1.8,14.66s5.76,9,9.49,13.1c1.47,1.61,3.33,3.39,5.78,3.34a8,8,0,0,0,3.63-1.19,37,37,0,0,0,16.84-48.29c-3.1-7.43-8.27-14.55-8.32-22.4,0-6.23,3.2-12.18,3.77-18.38.69-7.54-3.77-19.51-12.87-22.8C679.93,193.53,674.94,196,672.23,199.74Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#585268"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M672.23,199.74c-5.34,7.28.06,17.63-5.67,24.71-1.89,2.34-4.8,4-6.77,6.3-3.65,4.26-3.51,10.05-1.72,15.05s5,9.56,7.28,14.44c1,2.11,1.74,4.48.74,6.58-.7,1.46-2.15,2.57-3.28,3.83-3.68,4.11-3.78,9.82-1.8,14.66s5.76,9,9.49,13.1c1.47,1.61,3.33,3.39,5.78,3.34a8,8,0,0,0,3.63-1.19,37,37,0,0,0,16.84-48.29c-3.1-7.43-8.27-14.55-8.32-22.4,0-6.23,3.2-12.18,3.77-18.38.69-7.54-3.77-19.51-12.87-22.8C679.93,193.53,674.94,196,672.23,199.74Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45,464.55c-10.69.56-20.75,5.16-30.11,10.36S682.92,486,672.85,489.69",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M724.81,489.74a44.07,44.07,0,0,0-27.75,13.5c-2.6,2.75-4.84,5.83-7.55,8.47a33.54,33.54,0,0,1-14.88,8.43",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M727,508.91a48.52,48.52,0,0,0-22.32,13.46c-1.64,1.77-3.13,3.66-4.77,5.43-8.85,9.5-21.35,14.54-33.42,19.31",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M726.09,243.06a219.46,219.46,0,0,0,2.2,25.52c1,6,2.4,11.4,4.41,13.79,5.88,7-28.65,16.35-28.65,16.35l-20.39-15.8s16.16-14.88,8.63-29.39S726.09,243.06,726.09,243.06Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#cc818c"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M658.79,398.82h81.55c-2.27-6.16-3.78-10.65-3.78-10.65l-77.14,4.4Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M653.54,397.35h87.19c-2.45-8.77,0-16.88,3.49-23.12a51.1,51.1,0,0,1,9.13-11.84l.6-.55,30.44-6.74,1.64-.36s.25-55.35-19.35-62.95-31.35-17.87-31.35-17.87l-26.93,8.32-19.84-10c-6.37,6.85-23.27,4.16-23.27,4.16-27.67,3.18-27.67,24-27.67,24s16.16,37.71,17.39,37.71S653.54,397.35,653.54,397.35Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M683.64,362.16s-17.78-3.94-23.83-10.83",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M773.29,341.51l-20.62,16.9a35.13,35.13,0,0,0,.68,4l.6-.55,30.44-6.74Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M717.46,391.47s4.51,2.54,11.42,5.88h11.85c-2.45-8.77,0-16.88,3.49-23.12l-20.89-6.76C730.44,374.08,717.46,391.47,717.46,391.47Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M649.86,293.76l-12.24,6.61-12,30.37s-12.49,33.3-11.27,42.12c0,0-4.4,20.82,3.43,24.49l20.4,9.24a1.9,1.9,0,0,0,2.45-2.62c-2.91-5.51-6.11-14.13-1-18.87l-5.88-12.24L655,338.08l7.1-12Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M677.09,355.21c1.06,4.32,4.64,11,16.49,13.49l13,10.65,13.83,6.27,5.64,2.55,2.39-17.27-5.43-3-6.33-3.46s-14.28-25.87-36.89-15A5,5,0,0,0,677.09,355.21Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M677.83,353.74c1.06,4.33,4.63,11,16.48,13.49l13,10.65,13.84,6.27,5.63,2.55,2.39-17.27-5.43-3L717.46,363s-14.29-25.87-36.9-14.95A5,5,0,0,0,677.83,353.74Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#cc818c"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.15,
    cy: 213.73,
    r: 31.59,
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.15,
    cy: 213,
    r: 31.59,
    fill: "#cc818c"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M722.88,300.64l-9.5-18.46s13.9-5.62,14.91-12.13,13.32,7.63,10.66,12.32S722.88,300.64,722.88,300.64Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M722.88,299.17l-9.5-18.46s13.9-5.62,14.91-12.13,13.32,7.64,10.66,12.32S722.88,299.17,722.88,299.17Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M645.13,346.86l52.49,70.57s-19.35,10.53-46-8.32l-11.51-13.72L607.25,340Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#f6f8fb"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M634.8,385.23l4.78-.13s29.2-28.34,36.37-14-18.19,27.74-18.19,27.74L650.05,403,640,406l-6.43-8.63Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#cc818c"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M641.85,400.54c.44,1.63.86,3.43.12,4.94a2,2,0,0,1-.87.95,2.23,2.23,0,0,1-1,.14,10.05,10.05,0,0,1-6.59-3.26,30.1,30.1,0,0,1-4.27-6.18c-1.3-2.27-2.65-4.78-2.19-7.36.52-2.81,3-4.76,5.43-6.34,4.84-3.2,5,.53,6.06,4.65S640.74,396.38,641.85,400.54Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M641.12,400.54c.43,1.63.86,3.43.12,4.94a2,2,0,0,1-.87.95,2.25,2.25,0,0,1-1,.14,10,10,0,0,1-6.59-3.26,29.75,29.75,0,0,1-4.28-6.18c-1.3-2.27-2.65-4.78-2.18-7.36.51-2.81,3-4.76,5.42-6.34,4.85-3.2,5,.53,6.07,4.65S640,396.38,641.12,400.54Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "623.85 317.94 626.29 313.81 624.16 321.48 623.85 317.94",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M721.19,384.15l5.63,2.55,2.39-17.27-5.43-3C727.53,370.73,724.25,378.68,721.19,384.15Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M743.79,364.1s-18.18,1.11-25.9-3.85",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.53,375.7a51.18,51.18,0,0,1,9.13-11.85,24.37,24.37,0,0,1,2.69-1.46l28.34-5.82,1.64-.36s.25-55.35-19.34-62.95a117.72,117.72,0,0,1-30.56-17.21l2.15-.66s11.75,10.28,31.35,17.87,19.34,62.95,19.34,62.95h-2.94l-29,5.55s-1.25,1.21-1.63,1.56a56.2,56.2,0,0,0-9.27,12.26A30.74,30.74,0,0,0,741,398.82H738C735.58,390.05,738.08,381.94,741.53,375.7Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.13,278c.47-.07.92-.14,1.41-.19a50.71,50.71,0,0,0,6,.49A54.54,54.54,0,0,1,664.13,278Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.7,283.71l-17.94-9.08a9.48,9.48,0,0,0,1-.95l18.72,9.47Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M774,340l12,14.7,2.45,39.92s3.18,20.32-20.08,15.42S718.19,390,718.19,390s13-17.39,5.88-24l33.31,10.78s5.63-1.23,1.22-6.12-5.19-13.72-5.19-13.72Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M779.42,382.17l6.61,7.59A9.53,9.53,0,0,1,779.42,382.17Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.99 360.8 747.28 374.02 742.14 375.25 736.99 360.8",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M665.58,218.64c-1.13-2.77-.26-6,1.1-8.61s3.23-5.08,4.25-7.89c1.51-4.18,1.05-8.91,2.7-13,2.91-7.25,11.18-10.49,18.59-13,2.19-.73,4.52-1.46,6.76-.92,3,.71,4.95,3.43,7.4,5.26,10.06,7.5,26.42-.76,36.15,7.18,3.72,3,5.53,7.91,6.09,12.68s0,9.61-.06,14.42c-.16,8.42,1.42,17.63,7.72,23.21,1.9,1.68,4.14,2.94,6,4.68s3.32,4.17,3,6.69a23.19,23.19,0,0,1-1,3.4c-1.25,4.39.62,9,2.9,13,6.8,11.77,18.79,21.47,32.38,21.74-.91,6.86-8,10.84-14.35,13.65-8,3.59-16.52,7.11-25.33,6.66s-18-6.09-19.54-14.77c-.53-3-.46-6.61-3-8.17-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.16,56.16,0,0,1-2.61-16c-.11-6.44.74-13.47-2.91-18.77-3.38-4.91-9.38-7.4-13.28-11.91-3.6-4.18-7.51-9.22-13.41-10C687.28,219.36,670.4,230.45,665.58,218.64Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M665.58,217.17c-1.13-2.77-.26-6,1.1-8.61s3.23-5.08,4.25-7.89c1.51-4.18,1.05-8.91,2.7-13,2.91-7.26,11.18-10.5,18.59-13,2.19-.73,4.52-1.46,6.76-.92,3,.71,4.95,3.43,7.4,5.26,10.06,7.5,26.42-.76,36.15,7.18,3.72,3,5.53,7.91,6.09,12.69s0,9.6-.06,14.41c-.16,8.42,1.42,17.63,7.72,23.21,1.9,1.68,4.14,2.94,6,4.68s3.32,4.17,3,6.69a23.19,23.19,0,0,1-1,3.4c-1.25,4.39.62,9,2.9,13C774,276,785.94,285.73,799.53,286c-.91,6.86-8,10.84-14.35,13.66-8,3.58-16.52,7.1-25.33,6.65s-18-6.09-19.54-14.77c-.53-3-.46-6.61-3-8.17-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.1,56.1,0,0,1-2.61-16c-.11-6.44.74-13.47-2.91-18.77-3.38-4.91-9.38-7.4-13.28-11.91-3.6-4.18-7.51-9.22-13.41-10C687.28,217.89,670.4,229,665.58,217.17Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#585268"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M688,298.35l18.11-14.7s-12.4-6.72-13.88-12.45-11.4,2.72-10.39,7.86S688,298.35,688,298.35Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M688.71,296.14l18.11-14.69S694.42,274.73,693,269s-11.4,2.72-10.39,7.86S688.71,296.14,688.71,296.14Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.37,
    cy: 273.61,
    r: 1.44,
    opacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.37,
    cy: 281.61,
    r: 1.44,
    opacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.37,
    cy: 289.6,
    r: 1.44,
    opacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.89,196.75c1.43-3.93,1.12-8.34,2.46-12.3a13.44,13.44,0,0,0-1.53,2.82c-1.66,4.13-1.19,8.86-2.71,13l-.1.24A22.85,22.85,0,0,0,672.89,196.75Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.14,295.74c-8,3.58-16.52,7.1-25.33,6.65s-18-6.09-19.54-14.76c-.53-3-.46-6.62-3-8.18-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.1,56.1,0,0,1-2.61-16c-.11-6.43.75-13.46-2.9-18.77-3.39-4.91-9.39-7.39-13.29-11.91-3.6-4.17-7.51-9.22-13.41-10-8.09-1.1-25,10-29.78-1.82a9.3,9.3,0,0,1,.31-6.83c-.35.59-.69,1.18-1,1.78-1.36,2.66-2.22,5.85-1.09,8.62,4.81,11.8,21.69.71,29.78,1.82,5.9.8,9.81,5.85,13.41,10,3.9,4.52,9.9,7,13.28,11.92,3.66,5.3,2.8,12.33,2.91,18.76a56.1,56.1,0,0,0,2.61,16c.8,2.52,2,5.22,4.43,6.24,1.68.71,3.7.48,5.26,1.42,2.58,1.56,2.51,5.21,3,8.18,1.56,8.67,10.74,14.31,19.54,14.76s17.28-3.06,25.33-6.65c5.8-2.58,12.26-6.15,14-12C796.58,291.11,791.66,293.73,787.14,295.74Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M963.87,352.18C942.7,340,934.7,337,934.66,337l-.44-.31a17.61,17.61,0,0,1-5.33-6.74,14.07,14.07,0,0,1,0-1.45.61.61,0,0,0,0,.14c.33-6.45,4.92-12.32,9.27-17.44l11.13-13.09a12.9,12.9,0,0,0,2.87-4.54,10.47,10.47,0,0,0,.3-2.79c0-.38,0-.76,0-1.14-.06-3.25-.15-6.51-.27-9.76-.1-2.84-.83-6.42-3.67-7-1.48-.3-3.44.23-4.22-1a2.43,2.43,0,0,1-.19-1.69.58.58,0,0,0,0,.14l0-.16a37.67,37.67,0,0,0,1.05-6.69,9.12,9.12,0,0,0-.46-3.39c-1.64-4.71-7.31-6.65-12.32-7.54s-10.63-1.65-13.77-5.57a40.73,40.73,0,0,0-2.74-3.77,10.81,10.81,0,0,0-5.12-2.53,29,29,0,0,0-18.63,1.62c-2.42,1.08-4.85,2.54-7.51,2.38s-5.12-2.08-7.84-2.54c-4.4-.75-8.61,2.48-10.78,6.31a15.43,15.43,0,0,0-2,7.44v.44h0a10.88,10.88,0,0,0,2.86,7.6c1.9,2,4.72,3.32,5.51,5.91.32,1.05.24,2.19.53,3.26a2.91,2.91,0,0,0,.12.39l-.14.19a33,33,0,0,0-7,20.34,33.76,33.76,0,0,0,23.72,32c0,.33,0,.66,0,1,0,4-1.15,8.17-4.6,11.2L855,350.2s-18.08-2.15-24.6,24.27a45.05,45.05,0,0,0-1.12,13.4c.24,4-.31,11-5,20.07-7.41,14.52-5.72,47.85,9.44,51.15,14.31,3.12,19.91,1.82,20.5,1.67l0,.58c-.24,6.26-2.51,60.2-10.76,66.72-2.28,1.81-1.86,3,0,3.85,0,0,0,.35-.05,1-.25,4-1.52,19-7,27.52-6.41,9.9-5.74,67-5.74,67l-4.37,33.66s2.69,20.79,0,24.42c-2.41,3.23-5.61,80.14-6.28,96.82h-.28a8.12,8.12,0,0,0-6.48,4c-3.54,5.75-15.94,16.38-15.94,16.38-2.69,3.82-12.64,7.48-17.9,9.2a11.12,11.12,0,0,0-2,.88,10.67,10.67,0,0,0-4.52,4.76,5.11,5.11,0,0,0-.48,4c1.34,3.29,29.31,5.61,36.39,2.3,5.56-2.59,27.6-6,36.75-7.34a7.54,7.54,0,0,0,6.54-6.54,4.31,4.31,0,0,0-.84-3.27,0,0,0,0,0,0,0c-1.75-2.17-2.64-8.1-3-12a8.11,8.11,0,0,0,2.06-1.22,87.85,87.85,0,0,1,5-35.31c6.74-17.82,8.76-50.82,7.08-72.27,0,0,20.55-88.44,36.73-96.69h0c.25.32,8.1,10.39,9.1,41.58,1,31.68,12.46,52.47,12.46,52.47s-5.06,53.79,0,73.92l-6.61,31.75c-.49-.41-.8-.73-.8-.73s.2.88.47,2.29l-.14.68.29.06c.75,4,1.86,10.89,1.4,15-.26,2.31-.91,5.48-1.35,8.59-.7,4.89-.89,9.63,1.68,10.67,4.22,1.7,29,4,33.2-1.44a7.79,7.79,0,0,0,1.22-8.15,8.25,8.25,0,0,0-1.22-2.08s-6.58-10.75-4.72-18.33a5.58,5.58,0,0,0-.79-4.35c.29-3.72,1.79-20.94,5.67-35.56,4.22-15.88,13.11-50.7,6.57-73.59h0q-.37-1.35-.84-2.64a98.84,98.84,0,0,1-3.71-38.61,78.69,78.69,0,0,1,0-33.66c4.05-18.48,6.88-36.63,6.88-36.63s2.23-24.42.28-39.39c0-.32-.09-.64-.13-1l1.06-.24s-5.73-25.41-7.75-41.58c-.48-3.82-1.1-8.65-1.78-13.81a35.25,35.25,0,0,0,5.49-1.37c18.19-6.27,23.92-63,23.92-63v-18S985.1,364.39,963.87,352.18ZM828.31,790.42c-.56-.28-.89-.47-.89-.47h0Z",
    transform: "translate(-31.16 -20.14)",
    fill: "url(#422858ff-741c-491e-b83f-4f975ae951a6)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M952.89,679.71c7.89,22.69-1.32,59.52-5.6,76s-5.59,36.18-5.59,36.18c-16.77,2.63-28.94-.66-28.94-.66l6.91-33.87c-4.94-20.06,0-73.67,0-73.67s-11.18-20.72-12.17-52.29c-1-31.07-8.63-41.12-8.87-41.43h0c-15.78,8.22-35.84,96.36-35.84,96.36,1.64,21.37-.34,54.26-6.91,72a89,89,0,0,0-4.93,35.18c-2.3,2-5.5,2.28-9,1.72-9.39-1.52-20.65-9.61-20.65-9.61s3.61-96,6.25-99.64,0-24.34,0-24.34l4.27-33.54s-.66-56.9,5.59-66.76c5.4-8.52,6.64-23.5,6.88-27.43,0-.62,0-1,0-1l9.52-11.4s92.08-6.91,99,0c1.69,1.69,2.74,5.55,3.36,10.4,1.9,14.92-.28,39.25-.28,39.25s-2.76,18.09-6.71,36.5a80.12,80.12,0,0,0,0,33.55A100.43,100.43,0,0,0,952.89,679.71Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#65617d"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M947.13,823.91c-4.11,5.43-28.28,3.13-32.4,1.44-2.51-1-2.32-5.77-1.64-10.64.43-3.09,1.06-6.25,1.32-8.55.65-5.92-2-17.93-2-17.93s5.42,5.76,6.73,0c.58-2.52,2.6-3.81,4.7-4.46a12.28,12.28,0,0,1,8.54.53c4.27,1.86,11.39,5.81,10.12,11.15-1.81,7.55,4.6,18.27,4.6,18.27a8.32,8.32,0,0,1,1.2,2.06A7.89,7.89,0,0,1,947.13,823.91Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#a27772"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M947.13,823.91c-4.11,5.43-28.28,3.13-32.4,1.44-2.51-1-2.32-5.77-1.64-10.64,2.6,1.22,7,2.23,14.37,1.55a40.54,40.54,0,0,1,5.17-.16,120.23,120.23,0,0,0,15.7-.32A7.89,7.89,0,0,1,947.13,823.91Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M862.78,686.29c1.64,21.37-.34,54.26-6.91,72a89,89,0,0,0-4.93,35.18c-2.3,2-5.5,2.28-9,1.72,2-13.87,10.44-73.63,15.85-120.85,6.17-53.77,35-90.76,35-90.76l5.75,6.33C882.84,598.15,862.78,686.29,862.78,686.29Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M937.26,340.65l-4,19.73-19.67,33.05-24.25-10.36s-33-34.53-12.25-39.46a18.36,18.36,0,0,0,6.88-3.06c4.07-3.07,5.35-7.53,5.37-11.9A36.48,36.48,0,0,0,886,314.51l42.42-13.32a68.09,68.09,0,0,0-3,17.18c-.33,11.56,4,17.25,7.49,20A12.74,12.74,0,0,0,937.26,340.65Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fbbebe"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M928.38,301.19a68.09,68.09,0,0,0-3,17.18,32.29,32.29,0,0,1-2.47,2.63,33.56,33.56,0,0,1-33.54,7.65A36.48,36.48,0,0,0,886,314.51Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M933.25,295.76a33.55,33.55,0,1,1-33.55-33.54A33.39,33.39,0,0,1,933.25,295.76Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fbbebe"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M937.26,340.65l-4,19.73-19.67,33.05-24.25-10.36s-33-34.53-12.25-39.46a18.36,18.36,0,0,0,6.88-3.06c-3.74,10.28,11.7,31.67,11.7,31.67,1.8,2.65,5.92,1,5.92,1,9.95-1.51,28.26-30.12,31.25-34.88A12.74,12.74,0,0,0,937.26,340.65Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M956.25,531.93c-5.84,1.33-38.15,8.48-50.4,6.69-13.48-2-39.69-3.28-39.69-3.28s-16.69.9-21.83-1.45c0-.62,0-1,0-1l9.52-11.4s92.08-6.91,99,0C954.58,523.22,955.63,527.08,956.25,531.93Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M895.66,373.21s-17.35-24-10.81-33.4l-29.31,12s-17.64-2.14-24,24.19a45.81,45.81,0,0,0-1.09,13.36c.24,4-.3,11-4.83,20-7.23,14.47-5.59,47.69,9.21,51S854.88,462,854.88,462s-2,60.18-10.52,67.09,21.8,5.26,21.8,5.26,26.21,1.32,39.7,3.29,51.3-6.91,51.3-6.91-5.59-25.32-7.57-41.43S943,438.87,943,438.87l33.54-45.44s5.92-27.46-14.8-39.63-28.51-15.15-28.51-15.15-20.82,33.9-31.67,35.54C901.58,374.19,897.46,375.85,895.66,373.21Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M857.18,382.74s-.32,10.86,1.65,15.13,9.21,28,9.21,28H851.59s8.88-9.54,8.23-14.15S857.18,382.74,857.18,382.74Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M905.86,464.63s-36.32-8.88-39.7-16.44-12.71-24.49-12.71-24.49l3.83-5.16,17.66,13.86s21,16.77,30.92,18.42S905.86,464.63,905.86,464.63Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fbbebe"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M905.86,464.63s-36.32-8.88-39.7-16.44-12.71-24.49-12.71-24.49l3.83-5.16,17.66,13.86s21,16.77,30.92,18.42S905.86,464.63,905.86,464.63Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.05
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M937.26,421.88v19.7H934.1a92.07,92.07,0,0,0-44.72,11.58l-5.94,3.29-1.59.89-10.2-23,9.54-8.55.49,0c2.33.23,12.42,1.07,16.7-.37,4.06-1.38,9.1-5.75,21.06-2.7,5.89,1.51,10.93,8.11,16.64,6.05Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fbbebe"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M969,386l6.57,7.4v17.93s-5.59,56.56-23.34,62.81-49.46-3.62-49.46-3.62-8.19-21.7-4.36-23,33.85-9.24,33.85-9.24-.42-33.18,6.15-43.05c0,0-4.27-30.91,10.53-31.57S969,386,969,386Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M970,386l6.58,7.4v17.93s-5.59,56.56-23.35,62.81-49.46-3.62-49.46-3.62-8.19-21.7-4.35-23,33.85-9.24,33.85-9.24-.43-33.18,6.15-43.05c0,0-4.28-30.91,10.52-31.57S970,386,970,386Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M924.05,310a13.22,13.22,0,0,0-.75-6.41c-.93-2-3.1-3.51-5.22-3-2.81.66-4,4.32-6.78,5.2-2.33.74-4.87-.91-6-3.08s-1.14-4.72-1.14-7.16c0-2.74,0-5.49,0-8.24,0-3-.1-6.22-1.94-8.57-2.29-2.92-7.68-4.2-11.28-4.08a9.57,9.57,0,0,0-6.44,2.59c-1.92,1.64-4.15,2.84-6.77,2.41a5.83,5.83,0,0,1-4.72-4.08l0-.1A33.54,33.54,0,1,1,922.87,320,90.43,90.43,0,0,0,924.05,310Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M877.73,278.69A5.88,5.88,0,0,1,873,274.6c-.27-1.06-.2-2.19-.51-3.24-.77-2.59-3.53-3.93-5.38-5.9-3.7-3.93-3.46-10.39-.84-15.12,2.12-3.81,6.22-7,10.52-6.28,2.66.46,5,2.35,7.66,2.53s5-1.29,7.33-2.37A27.62,27.62,0,0,1,910,242.6a10.5,10.5,0,0,1,5,2.53,43.75,43.75,0,0,1,2.67,3.75c3.06,3.9,8.55,4.67,13.44,5.55s10.42,2.82,12,7.52c1.07,3.12,0,6.5-.58,9.74a2.94,2.94,0,0,0,.13,2c.77,1.26,2.68.73,4.12,1,2.77.59,3.48,4.16,3.59,7q.17,4.86.26,9.73a12.39,12.39,0,0,1-.29,3.6,12.71,12.71,0,0,1-2.79,4.53l-10.86,13.05c-4.82,5.78-9.93,12.52-9,20-2.28,1-5-.95-5.74-3.34s-.15-5,.36-7.41A90.85,90.85,0,0,0,924.05,309a13.18,13.18,0,0,0-.75-6.4c-.93-2-3.1-3.51-5.22-3-2.82.66-4,4.32-6.78,5.2-2.33.74-4.87-.91-6-3.08s-1.14-4.71-1.14-7.15l0-8.25c0-3-.1-6.22-1.94-8.57-2.29-2.92-7.68-4.2-11.28-4.08a9.57,9.57,0,0,0-6.43,2.59C882.58,277.91,880.35,279.12,877.73,278.69Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#7c5c5c"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M885.3,381.92l10.3,42.31S903.72,424.18,885.3,381.92Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M920.49,374.85s-13.48,22.08-8.22,44.92l2.51.18S910.3,409.38,920.49,374.85Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M929,499.82s16.56-5.48,17.76,7.23C946.8,507.05,943.68,498.34,929,499.82Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M881.19,426.81s-3.29,23,2.63,32.23c0,0-12,4.93-28.94,3.95l-2-36.18Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M883.44,456.45l-1.59.89-10.2-23,9.54-8.55h.49v0C881.53,426.93,878.87,446.7,883.44,456.45Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M881.19,425.83s-3.29,23,2.63,32.22c0,0-12,4.94-28.94,3.95l-11.51-36.17Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M852.75,809.91a7.45,7.45,0,0,1-6.39,6.52c-8.93,1.33-30.44,4.73-35.87,7.32-6.91,3.29-34.2,1-35.52-2.3a5.22,5.22,0,0,1,.47-4,10.54,10.54,0,0,1,4.41-4.74,11.7,11.7,0,0,1,2-.88c5.14-1.71,14.85-5.35,17.47-9.17,0,0,12.11-10.59,15.56-16.31a7.9,7.9,0,0,1,6.32-3.94c2.88-.13,6.09,1.32,7.41,7.63,0,0,15.77,9,20,1.11,0,0,.66,12.12,3.28,15.44v0A4.4,4.4,0,0,1,852.75,809.91Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#a27772"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M852.75,809.91a7.45,7.45,0,0,1-6.39,6.52c-8.93,1.33-30.44,4.73-35.87,7.32-6.91,3.29-34.2,1-35.52-2.3a5.22,5.22,0,0,1,.47-4,10.54,10.54,0,0,1,4.41-4.74c4.45,3,14.33,5.84,36.06,2.45,20.73-3.24,31-6.41,36-8.57v0A4.4,4.4,0,0,1,852.75,809.91Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.48,272.15l0-.16c.47-2.46,1.18-5,1-7.47a49.31,49.31,0,0,1-1,6A3.64,3.64,0,0,0,942.48,272.15Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.29,302.93a9.51,9.51,0,0,1,.81,3.76,11.34,11.34,0,0,0-.81-5.24c-.92-2-3.09-3.51-5.21-3-2.82.66-4,4.32-6.79,5.2-2.32.74-4.86-.91-6-3.08s-1.14-4.72-1.14-7.16c0-2.75,0-5.49,0-8.24,0-3-.1-6.22-1.94-8.57-2.3-2.93-7.68-4.2-11.28-4.09a9.58,9.58,0,0,0-6.44,2.6c-1.93,1.64-4.15,2.84-6.78,2.41a5.86,5.86,0,0,1-4.72-4.08c-.27-1.06-.2-2.2-.51-3.25-.77-2.58-3.53-3.93-5.38-5.89a10.77,10.77,0,0,1-2.77-7,11.21,11.21,0,0,0,2.77,8.43c1.85,2,4.61,3.31,5.38,5.89.31,1,.24,2.19.51,3.25a5.86,5.86,0,0,0,4.72,4.08c2.63.43,4.85-.77,6.78-2.41a9.58,9.58,0,0,1,6.44-2.6c3.6-.11,9,1.16,11.28,4.09,1.84,2.35,1.93,5.58,1.94,8.57,0,2.75,0,5.49,0,8.24,0,2.44,0,5,1.14,7.15s3.65,3.83,6,3.09c2.76-.88,4-4.54,6.79-5.2C920.2,299.42,922.37,301,923.29,302.93Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.32,293.88a12.64,12.64,0,0,1-2.8,4.52l-10.86,13.05c-4.57,5.49-9.4,11.85-9,18.86.33-6.43,4.81-12.28,9-17.38l10.86-13.05a12.64,12.64,0,0,0,2.8-4.52,12.48,12.48,0,0,0,.29-3.61A9.5,9.5,0,0,1,950.32,293.88Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922,328.11a7.69,7.69,0,0,1-.33-1.76,8.87,8.87,0,0,0,.33,3.24c.74,2.38,3.45,4.35,5.74,3.33a14,14,0,0,1-.12-1.44C925.34,332.39,922.7,330.45,922,328.11Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M812.69,789.36s3.44,6,15.9.72",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M918,790.82s10.74,12.65,24.28,4.15",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M949.26,641.23s-7.59,4.74-7.83,7.45,3.92-2,3.92-2Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M952.26,677.59a15.87,15.87,0,0,1-9.35,3.65c-5.68.25-5.2,7.65-1.49,5.43S952.26,677.59,952.26,677.59Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M953.7,682.34s-3.64,17.89-6.6,14.44",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M250.48,816.42s22.85,6.27,33.85-2.07,15.77-5.66,15.77-5.66,26.23-1.45,28.39-7.65-10.06-28.72-10.06-28.72c-.87-2-2.14-4.54-2.71-4.54l.12-9.5h0l3.8-39.75c8.77-22.49.16-51.55.16-51.55l-1.57-7.21a18.24,18.24,0,0,1,1.49-12l15.93-32a47.88,47.88,0,0,1,3-6.14c1-1.83,2.33-4.09,4-6.8.49-.78,1-1.59,1.56-2.44,1.93-3,4.27-6.4,7.1-10.32,7.05-9.77,10.76-22,12.68-31l.85,2.82h.05l.14,0h0l.23.05h0l.32,0h.06l.41.07h.15l4.9,62.36c.3,24.32,9.23,37.78,9.23,37.78l-1.23,53.69c1.68,12.93-2,30.17-3.69,37.05l-3.86,8.71a10.47,10.47,0,0,0-5.69,7.92c-.76,6.43-7.53,20.29-7.53,20.29-2.62,3.32-8.31,12.29-8.31,12.29S347.34,810.76,349,814s15.54,2.91,15.54,2.91c15.85,3.51,28-5,27.23-10.86s2.47-7.35,2.47-7.35c6.3-2,5.69-6.27,5.69-6.27a39.24,39.24,0,0,0-4.77-25.54l-1,2.31a35.17,35.17,0,0,1,1.9-13.63l-.58.4-.18.11-.06,0c1-8.77,10.21-25,10.21-25,16.92-29.68,10.77-69.9,10.77-69.9l-2.62-12.54-.15-4.73A157.87,157.87,0,0,1,416,610.21c.91-4.92,1.85-10.86,2.57-17.41,1.52-13.84,6.42-28.12,8.68-34.17l.67-.12H428c.92-.16,1.85-.32,2.79-.5l.18,0s.54-2.92,1-7.89c.27-3.17.49-7.19.49-11.81a132.87,132.87,0,0,0-6.31-41.11l.51-.73s1.21-1.64,3.42-4.48v0c4.06-5.16,10.38-13,18.17-21.84,13.95-15.91,9.85-32,9.85-32S448,401.14,443.5,378.92c-2.57-12.66-7.39-21.27-11.08-26.35a52.44,52.44,0,0,0,1.4-10.68c.3-6.58.07-13.44-2.89-19.35s-9.26-10.58-15.84-9.79a6.06,6.06,0,0,1-2.84,0,4.32,4.32,0,0,1-1.87-1.63c-3.85-5.31-4.1-12.45-2.9-18.89s3.66-12.6,4.76-19.06.6-13.63-3.51-18.75c-4.83-6-13.25-7.69-19.53-12.2-4.41-3.17-7.72-7.72-12.37-10.53s-9-1.74-14.05-.68c-8.49,1.79-16.56,2.61-24.59,6.26a65.49,65.49,0,0,0-21.43,15.59,20.34,20.34,0,0,0-4.78,7.54c-2,6.61,1.91,13.65,1.09,20.49-.58,4.85-3.44,9.07-5.71,13.4s-4,9.47-2.22,14c2.8,7.08,11.93,8.58,18.57,12.35a5.67,5.67,0,0,1,2.2,1.91c1.64,2.86-1.71,5.83-3.82,8.37a12.61,12.61,0,0,0-2.5,5.08,18.12,18.12,0,0,0-10.87,13.12c-2.25,10.07,1.21,22.78,4.26,31.18-3.33,18.71,1,26.09,4.19,28.92a16.05,16.05,0,0,1,5.56,10.94l0,.35c.21,3.4.57,6.79,1.05,10.17h0c-.11-.79-.22-1.63-.28-2-2.61,4.83-7.58,17.17-10.38,37.93a114,114,0,0,1-2.53,13.21,72.24,72.24,0,0,0-2.12,23.62l.5,6.73a2.12,2.12,0,0,1-1.36-.45l3.51,6.43V527a40,40,0,0,1-2.66,14.31c-.25.66-.52,1.32-.81,2a11.64,11.64,0,0,0-1.18,5.89c-7.55,11.57-24.86,76.41-24.86,76.41-9.39,21.26.77,35,.77,35s4.92,59.19,5.84,62.25S291.18,762,291.18,762h0c0,.95,0,1.94,0,2.87a6.73,6.73,0,0,0-1.71-.49c-8.23-.46-10.46,12.54-10.46,12.54L262.17,793s-7.69-1.3-19,7.19S250.48,816.42,250.48,816.42ZM418.63,474.33l-.05-.18-.46.27h0l-.19.11-.09.06h0l-7.76-27.39a45.48,45.48,0,0,1-.57-22.53l6-26.28h0v-6.32l19.07,50.82C435.8,449.74,424.47,466.33,418.63,474.33Z",
    transform: "translate(-31.16 -20.14)",
    fill: "url(#cb632b7f-b2f8-40b2-b1bc-4aa48a1a2180)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M427,557s-7.7,18.73-9.66,36.7c-.71,6.48-1.63,12.34-2.53,17.2a157.18,157.18,0,0,0-2.46,33.27l.15,4.67L415,661.21s6,39.73-10.57,69c0,0-9.82,17.53-10.12,25.83l-6.65,2.57-13.44-3.77s6.49-23.27,4.38-39.58l1.21-53S371.08,649,370.78,625l-5.13-65.86Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M365.65,547.62S364,573.3,351.3,591s-15.4,25.38-15.4,25.38L320.26,648a18.11,18.11,0,0,0-1.47,11.83l1.54,7.12s8.46,28.7-.15,50.91l-4.08,42.9H292.24s-2-35.65-2.87-38.67-5.74-61.48-5.74-61.48-10-13.6-.76-34.59c0,0,20.85-78.55,26.43-77.19S365.65,547.62,365.65,547.62Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.91,667l-1.53-7.12A18,18,0,0,1,317.84,648l15.64-31.65s2.71-7.7,15.4-25.38c12.19-17,14.2-41.36,14.34-43.23l2.43-.12S364,573.3,351.3,591s-15.4,25.38-15.4,25.38L320.26,648a18.11,18.11,0,0,0-1.47,11.83l1.54,7.12s8.46,28.7-.15,50.91l-4.08,42.9h-2.42l4.08-42.9C326.37,695.65,317.91,667,317.91,667Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M391.93,756.07c.3-8.3,10.12-25.83,10.12-25.83,16.62-29.3,10.57-69,10.57-69l-2.56-12.38-.15-4.67a157.18,157.18,0,0,1,2.46-33.27c.89-4.86,1.81-10.72,2.52-17.2,1.89-17.3,9.1-35.3,9.63-36.62L427,557s-7.7,18.73-9.66,36.7c-.71,6.48-1.63,12.34-2.53,17.2a157.18,157.18,0,0,0-2.46,33.27l.15,4.67L415,661.21s6,39.73-10.57,69c0,0-9.82,17.53-10.12,25.83l-6.65,2.57-1.4-.39Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M384.23,755.77a11.56,11.56,0,0,0,11-1.36,35.5,35.5,0,0,0-.9,19.94c2.72,10.88-25.38-8.76-25.38-8.76l6-13.71S377.28,756.22,384.23,755.77Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d39999"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M386.32,756.38a11.23,11.23,0,0,0,8.93-2,35.5,35.5,0,0,0-.9,19.94c2.72,10.88-25.38-8.76-25.38-8.76l6-13.71s1.74,3.34,6.85,3.86C383.37,755.89,384.85,756.1,386.32,756.38Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.32 481.5 301.06 481.5 301.06 414.89 292.25 413.31 289.32 481.5",
    fill: "#fdc2cc"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.32 481.5 301.06 481.5 301.06 414.89 292.25 413.31 289.32 481.5",
    opacity: 0.05
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M377.58,760.91s7.4-.46,10.72,6.19l4.08,3.17,2-4.68A39,39,0,0,1,399,790.82s.6,4.22-5.59,6.19c0,0-3.17,1.51-2.42,7.25s-11.17,14.2-26.73,10.72c0,0-13.6.31-15.26-2.87s1.06-11.63,1.06-11.63,5.59-8.86,8.15-12.13c0,0,6.65-13.7,7.41-20S373.65,757.43,377.58,760.91Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#7e5659"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M316.33,766.5l.12-9.39S302.94,761,292,756.6c0,0,.92,9.44-.6,10.73s5.06,13.44,5.06,13.44l7.35,7.7,12.64-4.6,3.43-10.8S317.23,766.5,316.33,766.5Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#d39999"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M316.33,766.5l.12-9.39S302.94,761,292,756.6c0,0,.92,9.44-.6,10.73s5.06,13.44,5.06,13.44l7.35,7.7,12.64-4.6,3.43-10.8S317.23,766.5,316.33,766.5Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M290.57,763.1s7.18.83,6.27,10,.38,0,.38,0,7.63,3.09,10.35,7.4,7.63-3.85,8-6.19S319,771,319,771s12,22.25,9.88,28.37S301,806.9,301,806.9s-4.69-2.64-15.49,5.59-33.23,2-33.23,2-18.28-7.63-7.17-16,18.65-7.1,18.65-7.1l16.54-15.94S282.49,762.64,290.57,763.1Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#7e5659"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M376.32,237.09c4.57,2.77,7.82,7.27,12.15,10.4,6.16,4.45,14.43,6.11,19.17,12.05,4,5.06,4.52,12.13,3.44,18.51s-3.5,12.47-4.67,18.83-.93,13.41,2.85,18.65a4.23,4.23,0,0,0,1.83,1.61,6,6,0,0,0,2.79,0c6.46-.78,12.66,3.84,15.56,9.67s3.13,12.61,2.83,19.11c-.25,5.33-.85,10.77-3.19,15.57-4,8.16-12.32,13.2-20.53,17.06a159,159,0,0,1-16.39,6.62c-3.84,1.3-7.89,2.47-11.88,1.79-6.83-1.18-11.67-7.39-18.15-9.82-5.31-2-11.2-1.28-16.85-.78-4.82.42-10.33.41-13.65-3.11-4.26-4.52-2.34-11.81-.16-17.63a12.55,12.55,0,0,1-8.88-20.52c2.06-2.51,5.35-5.44,3.74-8.27a5.48,5.48,0,0,0-2.16-1.88c-6.51-3.72-15.48-5.21-18.22-12.19-1.76-4.49-.06-9.57,2.17-13.84s5-8.45,5.61-13.23c.8-6.76-3-13.71-1.07-20.23a20.28,20.28,0,0,1,4.69-7.46,64.36,64.36,0,0,1,21-15.39c7.89-3.61,15.8-4.42,24.14-6.18C367.49,235.37,371.63,234.25,376.32,237.09Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#865a61"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M332.21,337.76s-19.13-1-22.75,15.31,7.85,39.67,7.85,39.67Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M332.21,337.76s-19.13-1-22.75,15.31,7.85,39.67,7.85,39.67Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.05
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M320,386.3l7.25,5.74,33.83,1.51,21.12-14.5,21.48-36.86c-13.13-3.35-18.44-12.42-20.42-20.9a45.76,45.76,0,0,1-.42-17.46s-34.44-17.83-30.21,10a37.8,37.8,0,0,1,.32,10.34c-2,16.3-17.82,13.23-17.82,13.23l-6.07,9.36-6.95,23Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M352.66,313.79a37.8,37.8,0,0,1,.32,10.34,30.53,30.53,0,0,0,30.31-2.84,45.76,45.76,0,0,1-.42-17.46S348.43,286,352.66,313.79Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.51,
    cy: 275.03,
    r: 30.51,
    fill: "#fdc2cc"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M344.09,380.48c.74,0,1.47.11,2.2.18,4,.4,20.71,1.3,30.23-10.07,10.65-12.72,24.83-28.43,25.41-29.07a0,0,0,0,1,0,0l14.43,4.36s-11.42-4.06-19,17.18a22,22,0,0,0,7.43,25.31,22.86,22.86,0,0,0,9.44,4,.05.05,0,0,1,0,.05v9.32h0l-5.9,26a45.07,45.07,0,0,0,.56,22.25l9,31.81a0,0,0,0,1,0,0c-1.36.94-57.2,38.92-94.5,12.69,0,0,0,0,0,0,.14-1.14,4.75-38.47,1.55-56.74a126.16,126.16,0,0,1-1.67-14.12c0-.12,0-.23,0-.35a15.92,15.92,0,0,0-5.47-10.8c-3.36-3-7.91-11-3.41-32.14a77.66,77.66,0,0,1,5-15.23l12.51-28.27s0,0,0,0l11.53.23a0,0,0,0,1,0,.08c-1,1.24-14.37,17.94-15.82,28.7C326.19,376.08,324.44,379.22,344.09,380.48Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M426.07,350.85s11.28,9.67,15.71,31.62,14.3,58.41,14.3,58.41,4,15.91-9.67,31.62-22.76,28-22.76,28l-9,13.26a11.29,11.29,0,0,1-6.48,4.58c-4.1,1.08-10.4,1.86-15.86-1.13a9.24,9.24,0,0,1-4-11.67l2-4.63s-18.53,11.68-20.14,5.23,21.55-12.89,21.55-12.89,19.13-3.22,23-12.28c0,0,20.54-26.39,18.93-35.45l-19.84-53.17S389,389.07,397.46,361.2,426.07,350.85,426.07,350.85Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M307.44,551.45s45.32,9.06,56,7.85l1.15,3.83s17.2,3.85,56.09-2.32q3.81-.6,7.91-1.35l.91-.16s.53-2.88.95-7.79c.93-11.15,1.26-32.74-6.59-54.84l-6.54-20.14s-40.42,24.23-67.18,22c-2.39-.2-4.76-.39-7.15-.47-5.49-.21-14,0-19.53-4.43l-11.6,2v33a39.54,39.54,0,0,1-2.62,14.12c-.25.66-.51,1.31-.8,2A10.5,10.5,0,0,0,307.44,551.45Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#65617d"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M364.58,552.86v10.27s19.8,4.43,64.91-3.83c0,0,.53-2.88.95-7.79C416.6,553.73,378.43,559.07,364.58,552.86Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M307.44,551.45s45.32,9.06,56,7.85l1.15,3.83V552.86c-5.16,2.14-42-6.74-55.35-10.07-.25.66-.51,1.31-.8,2A10.5,10.5,0,0,0,307.44,551.45Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M417.31,540l3.36,20.84q3.81-.6,7.91-1.35c-1.05-6.09-3.34-20-2.71-22.31l-4.23-3.62Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#65617d"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M417.78,539.55l3.36,20.85q3.81-.61,7.91-1.35c-1.05-6.09-3.34-20-2.71-22.31l-4.23-3.63Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.71,498.52c-2.38-.2-4.76-.39-7.15-.47-5.34-.2-13.49,0-19.05-4.09l1.94-.34c5.56,4.41,14,4.22,19.53,4.43,2.39.08,4.76.27,7.15.47.78.07,1.58.11,2.39.13A44.87,44.87,0,0,1,347.71,498.52Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.25,560.81q3.81-.6,7.91-1.34l.92-.17s.53-2.88.94-7.79c.94-11.15,1.27-32.74-6.59-54.84l-6.16-19c1.31-.74,2-1.17,2-1.17l6.54,20.14c7.85,22.1,7.52,43.69,6.59,54.84-.42,4.91-.95,7.79-.95,7.79l-.91.17q-4.09.74-7.91,1.34c-18.17,2.88-31.59,3.58-40.75,3.5A257,257,0,0,0,418.25,560.81Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,559.3l0,.11-1.3,0Q360.44,559.36,361,559.3Z",
    transform: "translate(-31.16 -20.14)"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.78,
    cy: 520.23,
    rx: 1.71,
    ry: 3.52,
    fill: "#d39999"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M313.8,469.09c2.76-20.5,7.63-32.68,10.2-37.45.1.65.36,2.76.48,3.41.52,3,.06,6.78.22,10.59L322.14,492l3.43,14.5c3.22,11.48-8.71,2.41-8.71,2.41-2.47,5.44-7,4.84-7,4.84l-.62-8.32a71.86,71.86,0,0,1,2.08-23.33A111.18,111.18,0,0,0,313.8,469.09Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M313.8,469.09c2.76-20.5,7.63-32.68,10.2-37.45.1.65.36,2.76.48,3.41.52,3,.06,6.78.22,10.59L322.14,492l3.43,14.5c3.22,11.48-8.71,2.41-8.71,2.41-2.47,5.44-7,4.84-7,4.84l-.62-8.32a71.86,71.86,0,0,1,2.08-23.33A111.18,111.18,0,0,0,313.8,469.09Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.05
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M428.58,494.1c-2.17,2.81-3.36,4.42-3.36,4.42l-9,13.25a11.24,11.24,0,0,1-6.48,4.58c-4.1,1.08-10.4,1.87-15.86-1.13a9.22,9.22,0,0,1-4-11.66l2-4.64s-18.53,11.68-20.14,5.24,21.55-12.89,21.55-12.89,19.13-3.22,23-12.29c0,0,1.67-2.14,4-5.42",
    transform: "translate(-31.16 -20.14)",
    fill: "#fdc2cc"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M417.31,516.31s-21.91-2.13-28.85-14.66L385.28,512s23,15.88,28.25,13.82Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#65617d"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M416.53,516.21s-21.9-2.13-28.85-14.67l-3.17,10.32s23,15.88,28.24,13.82Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M317.58,510.46s-7.67,2.72-9.18,1.21l3.45,6.35,6.52-5Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#65617d"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M317.58,510.46s-7.67,2.72-9.18,1.21l3.45,6.35,6.52-5Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "333.42 532.72 333.42 519.47 330.27 533.04 333.42 532.72",
    opacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M395.65,279.06c-1.85,2.6-5.06,3.92-8.22,4.33s-6.36.06-9.55,0c-5-.08-10.32.69-14.41,3.63-2.61,1.87-4.57,4.5-6.61,7-6.18,7.55-14.76,14.62-24.5,13.83a6.35,6.35,0,0,1-4.55-1.92,7.3,7.3,0,0,1-1.16-4.14,94.64,94.64,0,0,1,.59-18.66A39.34,39.34,0,0,1,330.06,272a38,38,0,0,1,6.78-9.68,41.47,41.47,0,0,1,11.83-9.48,21.22,21.22,0,0,1,14.8-1.91c5.83,1.59,10.37,6.15,15.93,8.5C385.75,262.1,402.61,269.23,395.65,279.06Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M395.65,277.85c-1.85,2.6-5.06,3.92-8.22,4.33s-6.36.06-9.55,0c-5-.09-10.32.68-14.41,3.62-2.61,1.87-4.57,4.5-6.61,7-6.18,7.55-14.76,14.62-24.5,13.83a6.31,6.31,0,0,1-4.55-1.92,7.27,7.27,0,0,1-1.16-4.14,94.64,94.64,0,0,1,.59-18.66,39.34,39.34,0,0,1,2.82-11.13,37.74,37.74,0,0,1,6.78-9.67,41.33,41.33,0,0,1,11.83-9.49,21.22,21.22,0,0,1,14.8-1.91c5.83,1.59,10.37,6.15,15.93,8.5C385.75,260.89,402.61,268,395.65,277.85Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#865a61"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.3 473.47 292.22 477.12 291.4 473.63 292.3 473.47",
    fill: "#fdc2cc"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.3 473.47 292.22 477.12 291.4 473.63 292.3 473.47",
    opacity: 0.05
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.58,359.29c-8.47,27.87,16.22,31.14,16.22,31.14l19.84,53.17c1.61,9.06-18.94,35.45-18.94,35.45-1.43,3.38-5,5.95-8.9,7.85a13.94,13.94,0,0,0,5.28-5.8s20.54-26.38,18.93-35.44l-19.84-53.18s-24.68-3.27-16.22-31.14c2.83-9.31,7-13.55,11.22-15.07C405.26,348.61,402.59,352.66,400.58,359.29Z",
    transform: "translate(-31.16 -20.14)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,384.61a20.84,20.84,0,0,0,4,3.79,22.73,22.73,0,0,0,9.44,4s0,0,0,.05v1a22.66,22.66,0,0,1-8.56-3.79A20.75,20.75,0,0,1,401,384.61Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.28,424.48c0,.11,0,.23,0,.35A129.15,129.15,0,0,0,326,439c3,17.24-.93,51.47-1.49,56.2-.32-.21-.64-.41-1-.64a.05.05,0,0,1,0,0c.15-1.14,4.76-38.47,1.56-56.73a126.72,126.72,0,0,1-1.67-14.12c0-.12,0-.24,0-.35a15.43,15.43,0,0,0-2.69-7.65A15.55,15.55,0,0,1,324.28,424.48Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,338.2l-9.78-.19a.05.05,0,0,0-.05,0l-12.5,28.26a77.91,77.91,0,0,0-5,15.23c-3.64,17.1-1.35,25.62,1.43,29.83-3.13-3.69-6.36-12.1-2.33-31a77.09,77.09,0,0,1,4.95-15.24L332,336.83s0,0,0,0l11.53.23a0,0,0,0,1,0,.07C343.44,337.25,343.13,337.63,342.69,338.2Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,345.87l.17.05Z",
    transform: "translate(-31.16 -20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.8,345.71,403,342.76a0,0,0,0,0-.05,0c-.58.64-14.75,16.35-25.4,29.07-9.52,11.37-26.21,10.48-30.23,10.08-.73-.08-1.47-.14-2.2-.19-10.93-.7-15.23-2-16.67-4.76,2.05,2,6.56,3,15.76,3.56.74,0,1.47.11,2.2.18,4,.4,20.71,1.29,30.23-10.07,10.65-12.73,24.83-28.44,25.41-29.08h0l14.26,4.32A8.91,8.91,0,0,0,412.8,345.71Z",
    transform: "translate(-31.16 -20.14)"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M296.77,777.63s-13.8,3.77-16.47-2.15",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M384.38,774.8s-16,4.13-19.7-2.26",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M615.1,765.85c.23-2,.56-4,.92-6,1.58-8.64-.83-16.88-2-20.28h0c-.37-1.05-.64-1.64-.64-1.64-6.37-1.74-31.48,17.74-40.63,25.08-3.17,0-6.61.14-10.37.39-1.64.12-3.28.16-4.92.13-1.47,0-3.56,0-6,0-8.49-6.84-34.77-27.41-41.31-25.63,0,0-.27.59-.64,1.64h0c-1.22,3.4-3.63,11.64-2.05,20.28.36,2,.69,4,.92,6,.49,4.39,2.33,12.82,9,18.51,1.43,10.4,6.78,24.07,10.9,32.37a23.18,23.18,0,0,0,1.4,4.57c-1.7,6.56-3.66,15.12-3.1,18,0,0-8.88-2.15-9.78,8.54,0,.1,0,.22,0,.33-3.21,1.47-7.22,4.84-2.71,11.9a4.63,4.63,0,0,0,2.32,1.89c.8.28,1.58.28,1.5-.84l5.55,6.25s10.06,1.16,10.18-4.68l.59.09c1.35.2,2.76.37,4.21.52l.7,2.31s-7.55-.16-5.49,4.49c0,0,1.9,1.76,2.55,1.12,0,0-1,3.05,2.94,3.05,0,0,4.23,2.24,5.88.64s5.07-4,5.39-5c.09-.27.13-2.64.15-5.92l.65,0c8.43.2,17.38-.07,25.52-.51l.66,0c0,3.55.05,6.17.14,6.45.33,1,3.76,3.37,5.4,5s5.87-.64,5.87-.64c3.92,0,2.94-3.05,2.94-3.05.66.64,2.56-1.12,2.56-1.12,2.06-4.65-5.5-4.49-5.5-4.49l.9-3,4.17-.35.66-.06c-.4,6.35,10.17,5.13,10.17,5.13l5.56-6.25c-.09,1.12.69,1.12,1.49.84A4.59,4.59,0,0,0,614,860c6.81-10.65-5.77-12.91-5.77-12.91a6.17,6.17,0,0,0-1.19-.19c0-.18,0-.37.05-.55h0a21.94,21.94,0,0,0,.08-4.22c-.47-1.93-3.57-5-7.49-5.45-2.56-.32-2.61-12.08-2.35-20.23a23.27,23.27,0,0,0,.4-4.64,24.48,24.48,0,0,0-1-7.43c5-8.48,9-17.37,9.45-20C612.77,778.64,614.61,770.24,615.1,765.85Z",
    transform: "translate(-31.16 -20.14)",
    fill: "url(#9b8149d4-8e0d-43dc-bd85-6bf0bb4ef8aa)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M605.42,846.9h0c-.4,5.54-1.47,14.43-1.47,14.43s-4.45.54-11.33,1.16l-4.67.4c-3.58.29-7.6.57-11.85.81-7.85.43-16.47.7-24.6.5-4.06-.09-8-.3-11.65-.66-1.63-.16-3.21-.35-4.71-.57-9.32-1.39-16-4.05-16.57-8.72a27,27,0,0,1-.21-6c.87-10.5,9.42-8.38,9.42-8.38-.55-2.9,1.52-11.91,3.2-18.43,1.06-4.11,2-7.23,2-7.23l60.12-4h.2a2.94,2.94,0,0,1,2.94,3.09c-.36,7.21-.87,23.72,2.08,24.09,3.78.47,6.77,3.46,7.23,5.35A22.44,22.44,0,0,1,605.42,846.9Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M554.36,767.76s-22.67,27.29-33.59,19.73c-.26-.18-.51-.36-.75-.55-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57,2-19.91h0c.36-1,.61-1.61.61-1.61C519.51,738.37,554.36,767.76,554.36,767.76Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M542.18,770.28s-7.14,5-17.21,13.22a36.36,36.36,0,0,1-5,3.44c-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57,2-19.91h0C525.42,743.06,542.18,770.28,542.18,770.28Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M542.18,770.28s-7.14,5-17.21,13.22a36.36,36.36,0,0,1-5,3.44c-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57,2-19.91h0C525.42,743.06,542.18,770.28,542.18,770.28Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fff",
    opacity: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M534.41,767.59s-3.81,2.69-9.19,7.06a19.35,19.35,0,0,1-2.64,1.83c-3.91-3-5-7.75-5.22-10.17-.11-1.06-.28-2.1-.47-3.15A21.86,21.86,0,0,1,518,752.54h0C525.47,753.06,534.41,767.59,534.41,767.59Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M569.05,767.76s22.67,27.29,33.59,19.73c.25-.18.51-.36.75-.55,7.34-5.56,9.27-14.52,9.78-19.07.22-2,.54-3.93.88-5.88,1.52-8.49-.8-16.57-2-19.91h0c-.36-1-.62-1.61-.62-1.61C603.9,738.37,569.05,767.76,569.05,767.76Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M581.22,770.28s7.15,5,17.22,13.22a36.36,36.36,0,0,0,4.95,3.44c7.34-5.56,9.27-14.52,9.78-19.07.22-2,.54-3.93.88-5.88,1.52-8.49-.8-16.57-2-19.91h0C598,743.06,581.22,770.28,581.22,770.28Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M581.22,770.28s7.15,5,17.22,13.22a36.36,36.36,0,0,0,4.95,3.44c7.34-5.56,9.27-14.52,9.78-19.07.22-2,.54-3.93.88-5.88,1.52-8.49-.8-16.57-2-19.91h0C598,743.06,581.22,770.28,581.22,770.28Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fff",
    opacity: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M589.05,767.57s3.79,2.68,9.13,7a18.31,18.31,0,0,0,2.63,1.82c3.89-2.95,4.92-7.7,5.19-10.11.11-1,.28-2.09.47-3.13a21.9,21.9,0,0,0-1.05-10.56h0C597.94,753.13,589.05,767.57,589.05,767.57Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M593.06,810.23c-2.86,4.52-5.9,8.6-8.68,11.06-9,8-47.86,4.82-50.38,4.41-.53-.09-1.63-1.66-3-4.21,1.06-4.11,2-7.23,2-7.23Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M562.3,765.47c-1.58.11-3.16.15-4.75.12-8.11-.14-35.43.22-38.46,11.25-3.57,13,12.39,47.81,14.9,48.23s41.36,3.57,50.39-4.41,20.78-33,20.15-35.27C604.53,785.39,615.73,761.77,562.3,765.47Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M561.44,786.55s-20-3.08-29.38,16.6a24,24,0,0,0,1.77,24.19c3.12,4.39,7.7,7.66,14.07,5C562.06,826.51,561.44,786.55,561.44,786.55Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M560.81,785.29s-20-3.08-29.38,16.6a24,24,0,0,0,1.77,24.19c3.12,4.39,7.7,7.66,14.07,5C561.43,825.25,560.81,785.29,560.81,785.29Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M560.81,785.92s-20-3.08-29.38,16.6a24,24,0,0,0,1.77,24.19c3.12,4.39,7.7,7.66,14.07,5C561.43,825.88,560.81,785.92,560.81,785.92Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M560.81,785.92s-20-3.08-29.38,16.6a24,24,0,0,0,1.77,24.19c3.12,4.39,7.7,7.66,14.07,5C561.43,825.88,560.81,785.92,560.81,785.92Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fff",
    opacity: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M539.24,803.13s-2.73,2.52-1.68,3.15S539.24,803.13,539.24,803.13Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M542.18,806.35s-1.49,3.29-.43,3.65,1.69-2.36,1.69-2.36Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M535.59,811.32s-1.46,3.88,0,3.88S535.59,811.32,535.59,811.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M533.78,821.71s2.92,7.46,10.52,6.93",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M540.61,823.91s3,2.94,6.29.84",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M564,786.55s20-3.08,29.38,16.6a24,24,0,0,1-1.77,24.19c-3.11,4.39-7.7,7.66-14.07,5C563.34,826.51,564,786.55,564,786.55Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M564.59,785.29s20-3.08,29.38,16.6a24,24,0,0,1-1.77,24.19c-3.11,4.39-7.7,7.66-14.07,5C564,825.25,564.59,785.29,564.59,785.29Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M564.59,785.92s20-3.08,29.38,16.6a24,24,0,0,1-1.77,24.19c-3.11,4.39-7.7,7.66-14.07,5C564,825.88,564.59,785.92,564.59,785.92Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M564.59,785.92s20-3.08,29.38,16.6a24,24,0,0,1-1.77,24.19c-3.11,4.39-7.7,7.66-14.07,5C564,825.88,564.59,785.92,564.59,785.92Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#fff",
    opacity: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M586.16,803.13s2.73,2.52,1.68,3.15S586.16,803.13,586.16,803.13Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M583.22,806.35s1.49,3.29.43,3.65-1.69-2.36-1.69-2.36Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M589.82,811.32s1.45,3.88,0,3.88S589.82,811.32,589.82,811.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M591.62,821.71s-2.92,7.46-10.52,6.93",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M584.8,823.91s-3,2.94-6.3.84",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M553.2,842.91c.53-.1,10.5-4.41,20.78,0Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M535.14,863c-9.32-1.39-16-4.05-16.57-8.72a27,27,0,0,1-.21-6,13.46,13.46,0,0,1,3.56-1.3c1.69-.47,3.78-.15,8.19,1.11s4.09,6.45,5,13.22A5.59,5.59,0,0,1,535.14,863Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M521.29,847.63s-12.12,2.22-5.56,12.68a4.47,4.47,0,0,0,2.24,1.85c.77.27,1.51.27,1.43-.83l5.36,6.14s10.7,1.26,9.76-5.51-.63-12-5-13.22S523,847.16,521.29,847.63Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M524.18,854.67s2.57,5.87,6.14.94",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M518.28,857s1.33,5.56,6.37,1.42",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M605.42,846.9h0c-.4,5.54-1.47,14.43-1.47,14.43s-4.45.54-11.33,1.16a5.81,5.81,0,0,1,0-1.16c.94-6.77.63-12,5-13.22C601.72,847,603.81,846.59,605.42,846.9Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M606.52,847.63s12.13,2.22,5.57,12.68a4.51,4.51,0,0,1-2.24,1.85c-.77.27-1.52.27-1.44-.83l-5.35,6.14s-10.71,1.26-9.76-5.51.63-12,5-13.22S604.84,847.16,606.52,847.63Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M603.64,854.67s-2.58,5.87-6.14.94",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M609.54,857s-1.34,5.56-6.38,1.42",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M551.5,864.2c-4.06-.09-8-.3-11.65-.66l-3.63-12.22a7.93,7.93,0,0,1-.33-2.23,7.78,7.78,0,0,1,15.55-.05C551.48,853.8,551.52,859.83,551.5,864.2Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M535.59,851.32l4.28,14.42s-7.28-.16-5.29,4.41c0,0,1.83,1.73,2.46,1.1,0,0-.95,3,2.83,3,0,0,4.08,2.21,5.66.63s4.89-3.94,5.21-4.88c.2-.62.14-12.68.07-21a7.76,7.76,0,0,0-7.77-7.7h0A7.77,7.77,0,0,0,535.59,851.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M541.37,869.47s-3.18,3-1.5,4.77",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M540,867.56s-2.94,1-2.94,3.69",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M591.71,849.09a7.91,7.91,0,0,1-.32,2.23L588,862.89c-3.58.29-7.6.57-11.85.81,0-4.32,0-10.07.07-14.66a7.77,7.77,0,0,1,15.54.05Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M592,851.32l-4.28,14.42s7.29-.16,5.3,4.41c0,0-1.83,1.73-2.46,1.1,0,0,.94,3-2.84,3,0,0-4.08,2.21-5.66.63s-4.88-3.94-5.2-4.88c-.2-.62-.14-12.68-.07-21a7.76,7.76,0,0,1,7.77-7.7h0A7.77,7.77,0,0,1,592,851.32Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M586.23,869.47s3.18,3,1.5,4.77",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M587.63,867.56s2.94,1,2.94,3.69",
    transform: "translate(-31.16 -20.14)",
    fill: "none",
    stroke: "#3f2b3b",
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M560.82,782.77s-14.81-.47-15.28,11,23.14,6.61,23.14,6.61,9.92-1.33,8.19-8.3S571.53,783.4,560.82,782.77Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M560.82,781.51s-14.81-.47-15.28,11,23.14,6.61,23.14,6.61,9.92-1.33,8.19-8.3S571.53,782.14,560.82,781.51Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M560.82,782.14s-14.81-.47-15.28,11,23.14,6.61,23.14,6.61,9.92-1.33,8.19-8.3S571.53,782.77,560.82,782.14Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#3f2b3b"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M527.78,839.92s5,1.78,6,5.19",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M598.28,837.4s-3.55,1.49-3.3,7.71",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.78,
    cy: 862.49,
    rx: 2.31,
    ry: 3.83,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -391.69, 359.3)",
    fill: "#112969"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.25,
    cy: 862.49,
    rx: 3.83,
    ry: 2.31,
    transform: "translate(-477.97 930.93) rotate(-60)",
    fill: "#112969"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.78,
    cy: 862.49,
    rx: 2.31,
    ry: 3.83,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -391.69, 359.3)",
    fill: "#fff",
    opacity: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.25,
    cy: 862.49,
    rx: 3.83,
    ry: 2.31,
    transform: "translate(-477.97 930.93) rotate(-60)",
    fill: "#fff",
    opacity: 0.5
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.6,
    cy: 716.06,
    rx: 26.93,
    ry: 4.55,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.51,
    cy: 780.59,
    rx: 26.93,
    ry: 4.55,
    fill: "#112969",
    opacity: 0.1
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.47,
    cy: 722.86,
    rx: 40.21,
    ry: 6.8,
    fill: "#112969"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M73,731.88a11.63,11.63,0,0,1-3.84-5.78c-.49-2.3.49-5.05,2.68-5.89,2.46-.94,5.09.76,7.08,2.48s4.28,3.69,6.89,3.33a10.49,10.49,0,0,1-3.24-9.82,4,4,0,0,1,.9-2c1.36-1.46,3.84-.83,5.48.32,5.19,3.66,6.65,10.72,6.67,17.08.53-2.3.09-4.68.1-7s.66-5,2.64-6.22a8,8,0,0,1,4-1c2.34-.08,4.94.15,6.54,1.86,2,2.12,1.47,5.69-.26,8s-4.35,3.8-6.76,5.42a14.92,14.92,0,0,0-4.84,4.61,4.72,4.72,0,0,0-.36.82H82.07A40.44,40.44,0,0,1,73,731.88Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#112969"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1029.83,
    cy: 754.12,
    rx: 26.93,
    ry: 4.55,
    fill: "#112969",
    opacity: 0.1
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.91,753.11s15.36-.47,20-3.77,23.62-7.23,24.77-1.94,23.09,26.29,5.74,26.43-40.29-2.7-44.91-5.52S1042.91,753.11,1042.91,753.11Z",
    transform: "translate(-31.16 -20.14)",
    fill: "#a8a8a8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.72,772c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.74-1.82,6.64-4.46C1099.36,771,1097.45,772,1093.72,772Z",
    transform: "translate(-31.16 -20.14)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContato);
export default __webpack_public_path__ + "static/media/contato.a77f8ec752d067979e365810e45a5b3e.svg";
export { ForwardRef as ReactComponent };